import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/pages/index/index.vue';
import HomePic from '@/pages/index/homepage/headPic.vue';
import Notices from '@/pages/index/homepage/notices.vue';
import Partners from '@/pages/index/homepage/partners.vue';

import UserList from '@/pages/index/approve/userList.vue';
import OrgApprove from '@/pages/index/approve/org.vue';
import UserApprove from '@/pages/index/approve/user.vue';

import GamesManager from '@/pages/index/games/games.vue';
import GameItemsManager from '@/pages/index/games/gameItems.vue';
import PointsManager from '@/pages/index/games/points.vue';

import FileManager from '@/pages/index/fileManager/index.vue';

import Login from '@/pages/login/index.vue';

import { getStorage } from '@/utils/storageUtils.js';

Vue.use(Router);

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};

let router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savePosition) {
    // 在点击浏览器的“前进/后退”，或者切换导航的时候触发。
    if (savePosition) {
      return savePosition;
    } else {
      var top;
      if (window.innerWidth >= 700) {
        top = 676;
      } else {
        top = 267;
      }
      return {
        x: 0,
        y: top,
      };
    }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        ,
        {
          path: '/',
          name: 'home',
          component: UserList,
        },
        {
          path: '/homepic',
          name: 'homePic',
          component: HomePic,
        },
        {
          path: '/notices',
          name: 'notices',
          component: Notices,
        },
        {
          path: '/partners',
          name: 'partners',
          component: Partners,
        },
        {
          path: '/userList',
          name: 'userList',
          component: UserList,
        },
        {
          path: '/orgapprove',
          name: 'orgApprove',
          component: OrgApprove,
        },
        {
          path: '/userapprove',
          name: 'userApprove',
          component: UserApprove,
        },
        {
          path: '/gamesmanager',
          name: 'gamesManager',
          component: GamesManager,
        },
        {
          path: '/gameitemsmanager',
          name: 'gameItemsManager',
          component: GameItemsManager,
        },
        {
          path: '/pointsmanager',
          name: 'pointsManager',
          component: PointsManager,
        },
        {
          path: '/filemanager',
          name: 'fileManager',
          component: FileManager,
        },
        {
          path: '/login',
          name: 'login',
          component: Login,
        },
      ],
    },
  ],
});

// 强制登录
router.beforeEach(function (to, from, next) {
  let token = getStorage('token');
  if (to.name != 'login' && !token) {
    router.replace({
      name: 'login',
    });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js